import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '../../utils/cn'

const textVariants = cva('', {
  variants: {
    size: {
      '4xs': 'text-4xs',
      '3xs': 'text-3xs',
      '2xs': 'text-2xs',
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-md',
      lg: 'text-lg'
    },
    tag: {
      p: 'p',
      span: 'span',
      h3: 'h3'
    }
  },
  defaultVariants: {
    size: 'md',
    tag: 'p'
  }
})

export type TextProps = React.ComponentProps<'p'> &
  VariantProps<typeof textVariants> & { color?: never }

export function Text({ className, children, size, tag = 'p', ...props }: TextProps) {
  const Component = tag || 'p'

  return (
    <Component className={cn(textVariants({ size }), className)} {...props}>
      {children}
    </Component>
  )
}
